/**
 * eBoutique API
 * eBoutique API
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export class TransactionQuerySearchCriteria { 
  loanNumber?: string;
  servicerNumber?: string;
  productType?: string;
  actionCode?: string;
  tranDesignator?: string;
  effectiveDateFrom?: string;
  effectiveDateTo?: string;
  postingDateFrom?: string;
  postingDateTo?: string;
  transactionStatus?: string;
  sortBy?: string;
}
